import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

const FileViews = ({ fileViews }) => {
  const intl = useIntl();

  return (
    <span className="file-views">
      {intl.formatMessage({
        defaultMessage: 'Views: {fileViews}',
      }, { fileViews: fileViews === null ? '' : fileViews })}
    </span>
  );
};

FileViews.propTypes = {
  fileViews: PropTypes.number,
};

FileViews.defaultProps = {
  fileViews: null,
};

export default FileViews;
